module.exports = __webpack_public_path__ + "img/volume-up.5bfa3859.svg";